import React, { Fragment } from 'react';
import cn from 'classnames';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Row } from 'antd';
import { withTranslation } from 'react-i18next';

import FIELD_TYPES from '../../../../../configs/fieldTypes';
import viewSettingsActions from '../../../../../actions/viewSettingsActions';
import { VIEW_MODES, SETTINGS_KEYS } from '../../../../../configs/viewSettings';

import SelectAxisX from './Select/AxisX';
import SelectAxisY from './Select/AxisY';
import SelectColor from './Select/Color';
import SelectSort from './Select/Sort';
import SelectSortDirection from './Select/SortDirection';

import styles from '../config.less';

class ConfigOverlay extends React.Component {
  static propTypes = {
    catalog: PropTypes.object.isRequired,
    catalogId: PropTypes.string.isRequired,
    viewSettings: PropTypes.object,
    viewMode: PropTypes.string,
    viewId: PropTypes.string,
  };

  onChange(key, value) {
    const { viewMode, viewId, catalogId } = this.props;

    viewSettingsActions.setOption({
      catalogId,
      viewMode,
      viewId,
      option: key,
      value,
    });
  }

  onSortChange(sortField, sortType) {
    const { viewMode, viewId } = this.props;
    const catalogId = this.props.catalog.get('id');

    // Select компонент теперь возвращает fieldId, а не value
    // Поддерживаем и Immutable и plain object
    const extractedFieldId = sortField && (sortField.get ? sortField.get('fieldId') : sortField.fieldId);
    viewSettingsActions.setSortingRecords({ catalogId, viewId, viewMode, sortField: extractedFieldId, sortType });
  }

  onSortFieldChange = (value) => {
    const { viewSettings } = this.props;
    const sortType = (viewSettings && viewSettings.getIn([SETTINGS_KEYS.SORTING_RECORDS, SETTINGS_KEYS.SORT_TYPE])) || -1;
    this.onSortChange(value, sortType);
  };

  onSortTypeChange = (value) => {
    const { viewSettings } = this.props;
    // API хранит fieldId
    let sortFieldId = viewSettings && viewSettings.getIn([SETTINGS_KEYS.SORTING_RECORDS, SETTINGS_KEYS.FIELD_ID]);
    // Если нет fieldId, используем дефолтное значение '#id'
    if (!sortFieldId) sortFieldId = '#id';
    let sortField = Immutable.fromJS({ type: 'field', fieldId: sortFieldId });
    this.onSortChange(sortField, value);
  };

  render() {
    const { catalog, viewSettings, viewMode, t } = this.props;
    const fields = catalog && catalog.get('fields');

    // viewSettings уже содержит настройки только для текущего viewMode (cards)
    const axisX = viewSettings && viewSettings.get(SETTINGS_KEYS.AXIS_X);
    const axisY = viewSettings && viewSettings.get(SETTINGS_KEYS.AXIS_Y);
    const color = viewSettings && viewSettings.get(SETTINGS_KEYS.COLOR);

    // API хранит sortingRecords: { sortType: -1, fieldId: '5' }
    const sortingRecords = viewSettings && viewSettings.get(SETTINGS_KEYS.SORTING_RECORDS);
    let sortFieldId = sortingRecords && sortingRecords.get(SETTINGS_KEYS.FIELD_ID);
    let sortField = sortFieldId && Immutable.fromJS({ type: 'field', fieldId: sortFieldId });
    const sortType = (sortingRecords && sortingRecords.get(SETTINGS_KEYS.SORT_TYPE)) || -1;

    const hasColor = fields && fields.find((field) => field.get('type') === FIELD_TYPES.DROPDOWN);

    return (
      <div className={cn('ant-dropdown-menu ant-dropdown-menu-vertical', styles.overlay)}>
        {viewMode === VIEW_MODES.CARDS ? (
          <>
            <Row className={styles.controlRow}>
              <label className={styles.controlLabel}>{t('records.cards.config.axisX.label')}</label>
              <SelectAxisX fields={fields} value={axisX} onChange={(value) => this.onChange(SETTINGS_KEYS.AXIS_X, value)} />
            </Row>
            <Row className={styles.controlRow}>
              <label className={styles.controlLabel}>{t('records.cards.config.axisY.label')}</label>
              <SelectAxisY fields={fields} value={axisY} onChange={(value) => this.onChange(SETTINGS_KEYS.AXIS_Y, value)} />
            </Row>
          </>
        ) : null}

        {hasColor ? (
          <Row className={styles.controlRow}>
            <label className={styles.controlLabel}>{t('records.cards.config.color.label')}</label>
            <SelectColor fields={fields} value={color} onChange={(value) => this.onChange(SETTINGS_KEYS.COLOR, value)} />
          </Row>
        ) : null}

        <Row className={styles.controlRow}>
          <label className={styles.controlLabel}>{t('records.cards.config.sort.label')}</label>
          <SelectSort fields={fields} value={sortField} onChange={this.onSortFieldChange} />
          <SelectSortDirection
            catalog={catalog}
            value={sortType}
            style={{ marginTop: '4px' }}
            onChange={this.onSortTypeChange}
          />
        </Row>
      </div>
    );
  }
}

export default withTranslation()(ConfigOverlay);
